// Minimal PKCE (S256) helpers using the Web Crypto API. No dependencies.
// Same as broker-workspace/src/auth/pkce.js.

function base64url(bytes) {
    const s = btoa(String.fromCharCode(...new Uint8Array(bytes)));
    return s.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function randomString(len = 48) {
    const a = new Uint8Array(len);
    crypto.getRandomValues(a);
    return base64url(a).slice(0, len);
}

export function newVerifier() {
    return randomString(64);
}

export async function challengeFor(verifier) {
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
    return base64url(digest);
}

export function newState() {
    return randomString(24);
}
